function parseTextWithLinks(text: string, styles = "") {
  // eslint-disable-next-line no-useless-escape
  const linkRegex = /\[([^\]]+)\]\(([^\)]+)\)/g;

  const parsedText = text.replace(
    linkRegex,
    (_, text, url) =>
      `<a class=${styles} href="${url}" target="_blank" rel="noreferrer">${text}</a>`,
  );

  return parsedText;
}

export default parseTextWithLinks;
